import React from 'react';
import { useHistory } from 'react-router-dom';
import Button from '@amzn/meridian/button';
import Icon from '@amzn/meridian/icon';
import cogTokens from '@amzn/meridian-tokens/base/icon/cog';
import Tooltip from '@amzn/meridian/tooltip';
import { HostSettingsUri } from '$/features/routes';
import { HostData } from '@amzn/dots-host-agent-management-service-client';

export type HostSettingsButtonProps = {
  host: HostData;
};

export function HostSettingsButton({
  host,
}: HostSettingsButtonProps): JSX.Element {
  const history = useHistory();
  return (
    <Tooltip title={`${host.accountName} Settings`} position="bottom">
      <Button
        type="tertiary"
        onClick={() => history.push(HostSettingsUri(host.accountName!))}
      >
        <Icon tokens={cogTokens} />
      </Button>
    </Tooltip>
  );
}
